export default interface ConfigInterface {
  space_id: string;
  environment: string;
  delivery_accessToken: string;
}